import { type Websocket, WebsocketEvent } from 'entities/WebSocket'
import type { IResponsePowerDialer } from 'entities/PowerDialer/api/types'
import type { CallPopUpPowerDialerStoreV2 } from 'widgets/CallPopUp/store/powerDialer/callPopUpPowerDialerStoreV2'

export const EventCallPopUpPowerDialerUpdated = {
  subscribe: (store: CallPopUpPowerDialerStoreV2, websocket: Websocket) => {
    return websocket.on(WebsocketEvent.PdCampaignsUpdated, (data: IResponsePowerDialer) => {
      if (store.currentPowerDialerId === data.id) {
        store.updatePowerDialer(data)
      }
    })
  },
}
